import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { Features } from './features';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class FeaturesService {

	statuses: any = [
		{ value: '0', name: 'Active' },
		{ value: '2', name: 'Suspended' },
		{ value: '1', name: 'Canceled' }
	];

	describesTypes: any = [
		{ name: 'BALCONY', value: 'BY' },
		{ name: 'MASTER_BATH', value: 'MB' },
		{ name: 'GUEST_BATH1', value: 'GB' },
		{ name: 'GUEST_BATH2', value: 'GB2' },
		{ name: 'GUEST_BATH3', value: 'GB3' },
		{ name: 'GUEST_BATH4', value: 'GB4' },
		{ name: 'GUEST_BATH5', value: 'GB5' },
		{ name: 'GUEST_BATH6', value: 'GB6' },
		{ name: 'GUEST_BATH7', value: 'GB7' },
		{ name: 'GUEST_BATH8', value: 'GB8' },
		{ name: 'GUEST_BATH9', value: 'GB9' },
		{ name: 'MASTER_BED', value: 'MD' },
		{ name: 'GUEST_BED1', value: 'GD' },
		{ name: 'GUEST_BED2', value: 'GD2' },
		{ name: 'GUEST_BED3', value: 'GD3' },
		{ name: 'GUEST_BED4', value: 'GD4' },
		{ name: 'GUEST_BED5', value: 'GD5' },
		{ name: 'GUEST_BED6', value: 'GD6' },
		{ name: 'GUEST_BED7', value: 'GD7' },
		{ name: 'GUEST_BED8', value: 'GD8' },
		{ name: 'GUEST_BED9', value: 'GD9' },
		{ name: 'ENTIRE_PROPERTY', value: 'EP' },
		{ name: 'HOT_TUB', value: 'HO' },
		{ name: 'DINING', value: 'DN' },
		{ name: 'LIVING', value: 'LV' },
		{ name: 'FAMILY', value: 'FF' },
		{ name: 'DEN', value: 'DE' },
		{ name: 'MUDROOM', value: 'MUD' },
		{ name: 'FITNESS', value: 'FR' },
		{ name: 'ENTERTAINMENT', value: 'ET' },
		{ name: 'OUTSIDE', value: 'OE' },
		{ name: 'FEATURE', value: 'FT' },
		{ name: 'LINEN', value: 'LN' },
		{ name: 'HEATING', value: 'HT' },
		{ name: 'COOLING', value: 'CL' },
		{ name: 'KITCHEN', value: 'KN' },
		{ name: 'LAUNDRY', value: 'LD' },
		{ name: 'PARKING', value: 'PK' },
		{ name: 'VIEW', value: 'VW' },
		{ name: 'FURNISHINGS', value: 'FN' },
		{ name: 'OTHER', value: 'OT' },
		{ name: 'BODY_BATH_PRODUCTS', value: 'BB' },
		{ name: 'ACTIVITIES', value: 'AC' },
		{ name: 'BBQ', value: 'BQ' },
		{ name: 'BEACH', value: 'BE' },
		{ name: 'CHILDREN_FEATURES', value: 'CD' },
		{ name: 'ENTRANCE', value: 'EN' },
		{ name: 'HEALTH_CLUB', value: 'HL' },
		{ name: 'POOL', value: 'PO' },
		{ name: 'RESTAURANT', value: 'RS' },
		{ name: 'SHOPPING', value: 'SP' },
		{ name: 'INTERIOR_SCHEMATIC', value: 'IS' },
		{ name: 'EXTERIOR_SCHEMATIC', value: 'ES' },
		{ name: 'BEDROOM', value: 'BD' },
		{ name: 'BATHROOM', value: 'BA' },
	];


	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService,
		) { }

	urlEndpoint = 'features';

	add(feature: Features): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(feature));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, feature);
	}

	update(feature: Features): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, feature);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}
	
	copySingleFeatureToShortTermRentals(propertyAndReportsObj: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(propertyAndReportsObj));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/property-features/copy-single-feature`, propertyAndReportsObj);
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
